import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldWrapper, FlexBox, InputText, Select, } from '@dixa/lib-shared-habla';
import { useEffect, useState } from 'react';
import { useUnmount } from 'react-use';
import { useBreakpointValue } from 'utils/mediaQuery';
import styles from './authorizationHeader.module.scss';
const authorizationOptions = [
    { id: 'none', name: 'None' },
    { id: 'bearer', name: 'Bearer' },
    { id: 'basic', name: 'Basic' },
    { id: 'custom', name: 'Custom' },
];
const defaultBasicAuth = {
    username: '',
    password: '',
};
const bearerPrefix = 'Bearer ';
const basicPrefix = 'Basic ';
export const AuthorizationHeader = ({ value, onChange, selectedAuthorizationType, setSelectedAuthorizationType, meta, disabled, }) => {
    var _a;
    const [basicAuth, setBasicAuth] = useState(defaultBasicAuth);
    const [authorization, setAuthorization] = useState('');
    const isSmallScreen = useBreakpointValue({ base: true, md: false });
    const handleBearerInitialization = (value) => {
        setSelectedAuthorizationType('bearer');
        setAuthorization(value.slice(bearerPrefix.length));
    };
    const handleBasicInitialization = (value) => {
        setSelectedAuthorizationType('basic');
        const basicValue = window.atob(value.slice(basicPrefix.length));
        const splitBasicValues = basicValue.split(':');
        if (splitBasicValues.length === 2) {
            setBasicAuth({
                username: splitBasicValues[0],
                password: splitBasicValues[1],
            });
        }
    };
    const handleCustomInitialization = (value) => {
        setSelectedAuthorizationType('custom');
        setAuthorization(value);
    };
    useEffect(() => {
        if (value &&
            basicAuth.password === '' &&
            basicAuth.username === '' &&
            authorization === '') {
            if (value.toLowerCase().startsWith(bearerPrefix.toLowerCase())) {
                handleBearerInitialization(value);
            }
            else if (value.toLowerCase().startsWith(basicPrefix.toLowerCase())) {
                handleBasicInitialization(value);
            }
            else {
                handleCustomInitialization(value);
            }
        }
    }, [value]);
    useUnmount(() => {
        onChange(undefined);
    });
    const validateBearer = (input) => {
        if (input.toLowerCase().startsWith(bearerPrefix.toLowerCase())) {
            return 'Remove the leading `Bearer` - it is set automatically.';
        }
        return null;
    };
    return (_jsxs(FlexBox, Object.assign({ gap: isSmallScreen ? '250' : '400', flexWrap: "wrap" }, { children: [_jsx(FieldWrapper, Object.assign({ disabled: disabled, label: "Authorization header", helpIcon: {
                    dark: true,
                    title: 'Authorization header',
                    text: 'Select the authorization type and enter the corresponding value. Use `custom` to have full control over the authorization value.',
                }, className: styles.authorization }, { children: _jsx(Select, { disabled: disabled, items: authorizationOptions, onSelect: (item) => {
                        setAuthorization('');
                        setBasicAuth(defaultBasicAuth);
                        onChange(undefined);
                        setSelectedAuthorizationType(item.id);
                    }, selectedItems: [selectedAuthorizationType || authorizationOptions[0]], className: styles.authorizationSelect }) })), selectedAuthorizationType === 'bearer' && (_jsx(FieldWrapper, Object.assign({ required: true, disabled: disabled, label: "Token", meta: Object.assign(Object.assign({}, meta), { warning: validateBearer(authorization) }) }, { children: _jsx(InputText, { disabled: disabled, status: ((_a = validateBearer(authorization)) !== null && _a !== void 0 ? _a : meta === null || meta === void 0 ? void 0 : meta.error) ? 'error' : undefined, value: authorization, onChange: (event) => {
                        setAuthorization(event.target.value);
                        onChange(`${bearerPrefix}${event.target.value}`);
                    }, placeholder: "Input bearer token", prefix: {
                        type: 'custom',
                        value: 'Bearer',
                    } }) }))), selectedAuthorizationType === 'basic' && (_jsxs(FlexBox, Object.assign({ flex: "1", gap: "200" }, { children: [_jsx(FieldWrapper, Object.assign({ disabled: disabled, required: true, label: "Username", meta: meta }, { children: _jsx(InputText, { disabled: disabled, value: basicAuth.username, onChange: (event) => {
                                setBasicAuth({
                                    username: event.target.value,
                                    password: basicAuth.password,
                                });
                                onChange(`${basicPrefix}${window.btoa(`${event.target.value}:${basicAuth.password}`)}`);
                            }, placeholder: "Username", status: FieldWrapper.getStatus(meta) }) })), _jsx(FieldWrapper, Object.assign({ disabled: disabled, required: true, label: "Password", meta: meta }, { children: _jsx(InputText, { disabled: disabled, value: basicAuth.password, onChange: (event) => {
                                setBasicAuth({
                                    username: basicAuth.username,
                                    password: event.target.value,
                                });
                                onChange(`${basicPrefix}${window.btoa(`${basicAuth.username}:${event.target.value}`)}`);
                            }, placeholder: "Password", status: FieldWrapper.getStatus(meta) }) }))] }))), selectedAuthorizationType === 'custom' && (_jsx(FieldWrapper, Object.assign({ disabled: disabled, required: true, label: "Custom", meta: meta }, { children: _jsx(InputText, { disabled: disabled, status: (meta === null || meta === void 0 ? void 0 : meta.error) ? 'error' : undefined, value: authorization, onChange: (event) => {
                        setAuthorization(event.target.value);
                        onChange(event.target.value);
                    }, placeholder: "Input authorization" }) }))), selectedAuthorizationType === 'none' && (_jsx(FlexBox, Object.assign({ alignSelf: "center", flex: "1", className: styles.authorizationEmpty, margin: isSmallScreen ? '0 0 250 0' : undefined }, { children: "No authorization header added" })))] })));
};
